export default "__VITE_ASSET__ggM$qpC1__"